export default {"src":"/_next/static/media/cowiconblack.52b288ea.svg","height":64,"width":64};